module.exports = __webpack_public_path__ + "media/images/old-ticbali-square-1999646610712a73e9dafe6eaab011e9.png";